class EmbroideryConfiguratorStudent extends HTMLElement {
  constructor() {
    super();

    this.container = this;
    this.body = document.querySelector('body');
    this.bodyClass = 'embroidery-drawer-is-open';
    this.form = this.closest('form');
    this.productId = this.form.querySelector('[name=id]').value;
    this.productSize = '';
    this.productLine = this.dataset.productLine1;
    this.cartNotification = document.querySelector('cart-notification');
    this.cartDrawer = document.querySelector('cart-drawer');
    this.options = {
      product: 'Product',
      line: 'Line',
      font: 'Font',
      color: 'Color',
      text: 'Text',
    };

    // set elements to work with later on
    this.embroiderySize = this.querySelectorAll('[data-embroidery-size]');

    // set elements we will work with
    this.summaryAddToCart = document.querySelector('[data-embroidery-student-add-to-cart]');
    this.agreeConditions = this.querySelector('[data-embroidery-agree-conditions]');
    this.embroideryNameLinesElem = this.querySelectorAll('[name="embroideryNameLines"]');

    // Set default values
    this.embroideryProductName = this.dataset.embroideryProductName;
    this.embroideryNameLines = '0'; // 0, 1 or 2
    this.embroideryNameLineFont = this.dataset.productFont;
    this.embroideryNameLineColor = this.dataset.productTextColor;
    this.embroideryNameLineText = 'Name';
    this.embroideryLogosMandatory = [];
    this.embroideryAgreeConditions = false;
    this.uniqueSKU = '';

    // Get current options form the element itself
    const dataOptions = JSON.parse(this.dataset.options);
    this.options = {
      ...this.options,
      ...dataOptions,
    };

    // Assign the name input field
    this.nameInputField = this.form.querySelector('input[name="embroideryNameLineText"]');

    // Add event listener to update embroideryNameLineText
    if (this.nameInputField) {
      this.nameInputField.addEventListener('input', (event) => {
        this.embroideryNameLineText = event.target.value;
      });
    }

    this.bindEvents();
    this.syncInputsWithOptions();
    this.checkImageAvailability();
  }

  bindEvents = () => {
    // Listen for input and checkbox changes in the form
    this.form.addEventListener('input', (event) => {
      this.handleFormInputs(event);
    });

    this.form.addEventListener('change', (event) => {
      this.handleFormInputs(event);
    });

    // Listen for input events on the container and store the values
    this.container.addEventListener('input', (event) => {
      let exceptions = ['embroideryLogosOptional[]'];
      let target = event.target;

      if (typeof this[target.name] !== 'undefined') {
        this[target.name] = target.value;
        if (target.type == 'checkbox') {
          this[target.name] = target.checked;
        }
      }

      this.agreeConditions.classList.remove('text-danger');
    });

    // Catch click on add to cart
    this.summaryAddToCart?.addEventListener('click', async (event) => {
      // Conditions not yet agreed, scroll into view
      if (!this.embroideryAgreeConditions) {
        this.agreeConditions.classList.add('text-danger');
        this.agreeConditions.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest',
        });
      } else {
        // Execute add to cart
        await this.addToCart(event);
      }
    });

    // Make sure we have the latest selected size
    this.getCurrentSize();
  };

  handleFormInputs = (event) => {
    let inputField = this.form?.querySelector('input[type="text"]');
    let checkbox = this.form?.querySelector('input[id="embroideryAgreeConditions"]');

    let isInputValid = inputField ? inputField.value.trim() !== '' : true;
    let isCheckboxChecked = checkbox ? checkbox.checked : false;

    this.toggleAddButton(!(isInputValid && isCheckboxChecked));
  };

  // Get the latest selected size and fill the title bar
  getCurrentSize = () => {
    document.querySelector('[data-option-position="0"]')?.addEventListener('input', (event) => {
      let sizeSelector = document.querySelector('.option__input-drawer:checked');

      if (sizeSelector) {
        this.productSize = sizeSelector.value;
        this.embroiderySize.forEach((elem) => {
          elem.innerHTML = `${sizeSelector.name}: ${sizeSelector.value}`;
        });
      }
    });
  };

  // Check if image is available on the configurator
  checkImageAvailability = () => {
    const spans = {
      oneWeek: document.querySelector('.embroidery-agree-conditions'),
      twoWeek: document.querySelector('.embroidery-agree-conditions-logo'),
    };

    const isOnlyText = this.dataset.productOptions === 'only-text';

    spans.oneWeek.classList.toggle('hidden', !isOnlyText);
    spans.twoWeek.classList.toggle('hidden', isOnlyText);
  };

  // Add to cart behavior
  // Base taken over from product-form.js but this caters a really specific usecase for the configurator
  addToCart = async () => {
    this.summaryAddToCart.setAttribute('disabled', true);
    this.summaryAddToCart.classList.add('button--loading');

    const sectionsToFetch = [
      ...this.cartDrawer.getSectionsToRender().map((section) => section.id),
      ...this.cartNotification.getSectionsToRender().map((section) => section.id),
    ];

    // Partner discount - set additional product properties that will grant discounts - for the discount to work, this requires Shopify functions
    let partnerPropertiesObject;
    if (this.form.querySelector('[data-partner-input-info]')) {
      const partnerInputs = Array.from(this.form.querySelectorAll('[data-partner-input-info]'));
      // Check if both partner name and restaurant inputs are filled
      const partnerNameInput = partnerInputs.find(
        (input) => input.dataset.partnerInputInfo === 'partnerName' && input.checked
      );
      const restaurantInput = partnerInputs.find(
        (input) => input.dataset.partnerInputInfo === 'partnerRestaurant' && input.value
      );

      if (partnerNameInput && restaurantInput) {
        // Get discount amount and type from partner input
        const discountAmount = partnerNameInput.getAttribute('data-discount-amount');
        const discountType = partnerNameInput.getAttribute('data-discount-type');

        partnerPropertiesObject = {};

        // Add discount amount and type properties
        if (discountAmount) partnerPropertiesObject._discount_amount = discountAmount;
        if (discountType) partnerPropertiesObject._discount_type = discountType;

        // Add partner input properties
        partnerInputs.forEach((input) => {
          if (
            (input.type === 'radio' && input.checked) ||
            (input.type !== 'radio' && input.value)
          ) {
            const propertyName = input.name.replace('properties[', '').replace(']', '');
            partnerPropertiesObject[propertyName] = input.value;
          }
        });
      }
    }

    // Build up the array for the cart
    const productItemArray = [];
    productItemArray.push({
      id: this.form.querySelector('[name=id]').value,
      option: this.productSize,
    });

    const allItems = [];
    let uniqueSKU = '';
    productItemArray.forEach((productItem) => {
      this.productId = productItem.id;
      uniqueSKU = this.buildUniqueSKU();

      // push the respective/existent Variant notes
      const variantNote = this.form.querySelector(`[data-variant-id-note="${this.productId}"]`);
      let variantNotePropertyName, variantNotePropertyValue;
      if (variantNote) {
        variantNotePropertyName = variantNote
          .querySelector('[data-variant-input-note]')
          .getAttribute('name')
          .replace('properties[', '')
          .replace(']', '');

        if (variantNote.querySelector('[data-variant-input-note]').value)
          variantNotePropertyValue = variantNote.querySelector('[data-variant-input-note]').value;
      }

      // get the pre-order property
      const preOrderProperty = this.getPreOrderProperty();

      allItems.push({
        id: productItem.id,
        quantity: productItem.quantity,
        properties: {
          _masterSKU: uniqueSKU,
          [variantNotePropertyName]: variantNotePropertyValue,
          ...preOrderProperty,
          ...partnerPropertiesObject,
        },
      });

      if (this.dataset.productOptions !== 'only-image') {
        // Not a logo, so we have to add lines, always add the first line
        allItems.unshift({
          id: this.productLine,
          quantity: productItem.quantity,
          properties: {
            [this.options.for]: `${this.embroideryProductName} (${productItem.option})`,
            [this.options.line + ' 1']: this.embroideryNameLineText,
            [this.options.font]: this.embroideryNameLineFont,
            [this.options.color]: this.embroideryNameLineColor,
            _productID: productItem.id,
            _linkedSKU: uniqueSKU,
          },
        });
      }

      // If we do not only have names to embroider, check all mandatory logos
      this.embroideryLogosMandatory.forEach((logo) => {
        allItems.unshift({
          id: logo,
          quantity: productItem.quantity,
          properties: {
            [this.options.for]: `${this.embroideryProductName} (${productItem.option})`,
            _productID: productItem.id,
            _linkedSKU: uniqueSKU,
            _mandatory: 'yes',
          },
        });
      });
    });

    // The array of items is complete, make sure we send extra data to rerender applicable sections
    const body = JSON.stringify({
      items: allItems,
      sections: sectionsToFetch,
      sections_url: window.location.pathname,
    });

    // This part has been taken over from product-form.js
    // A bit of duplicate code, but otherwise really custom for this plugin
    await fetch(window.Shopify.routes.root + 'cart/add.js', { ...fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.status == 422) {
          // When quantity error
          this.cartNotification.setActiveElement(document.activeElement);
          this.cartNotification.renderQuantityError(
            this.form.querySelector('[name=inventory_quantity]').value
          );
          return;
        }

        this.cartDrawer.renderContents(parsedState);
        setTimeout(() => {
          this.close(true);
          this.cartDrawer.open();
        });

        // reset all the variant note fields on form submission
        this.form
          .querySelectorAll('[data-variant-input-note]')
          .forEach((input) => (input.value = ''));
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.summaryAddToCart.classList.remove('button--loading');
        this.summaryAddToCart.removeAttribute('disabled');
      });
  };

  /**
   * toggleAddButton
   * @param {Boolean} disable
   * @returns {void}
   */
  toggleAddButton(disable = true) {
    // get the button on the PDP Summary or the button on the Purchase drawer if there's one
    let addButton = this.form?.querySelector('[name="add"]');

    if (disable) {
      addButton.setAttribute('disabled', true);
    } else {
      addButton.removeAttribute('disabled');
    }
  }

  // Sync the state in this object to the inputs on the form itself
  syncInputsWithOptions = () => {
    this.embroideryNameLinesElem.forEach((elem) => {
      elem.checked = this.embroideryNameLines === elem.value;
    });

    // Get all mandatory logos
    let values = [];
    let allFields = this.container.querySelectorAll(`[name="embroideryLogosMandatory[]"`);

    allFields.forEach((elem) => {
      if (elem.checked) values.push(elem.value);
    });
    this.embroideryLogosMandatory = values;
  };

  // Convert given text to a handle to easily compare with
  convertToHandle = (text) => {
    return text.replace(' ', '-').toLowerCase();
  };

  // Build up the unique SKU we supply to the cart
  // This way Shopify knows the distinctions between configured items with different values
  // This also groups exact same configurations into 1 item
  buildUniqueSKU = () => {
    let uniqueSKU = this.productId + '-student';

    // Add the name line 1 to the SKU
    uniqueSKU +=
      '-line1-' +
      this.embroideryNameLineFont +
      '-' +
      this.embroideryNameLineColor +
      '-' +
      this.embroideryNameLineText;

    // Add all mandatory logos to the SKU
    uniqueSKU += '-mandatory-logos-' + this.embroideryLogosMandatory.join('-');

    this.uniqueSKU = this.convertToHandle(uniqueSKU);
    return this.uniqueSKU;
  };

  updateProgress = () => {
    this.buildUniqueSKU();
  };

  close(closeAll = false) {
    this.body.classList.remove(this.bodyClass);

    if (closeAll) {
      this.body.classList.remove('purchase-drawer-is-open');
    }
  }

  /**
   * Gets pre-order property
   * @returns {Object} Pre-order property
   */
  getPreOrderProperty() {
    const input = this.form.querySelector('[data-pre-order-input]');
    if (!input) return {};

    const propertyName = input.getAttribute('name').replace('properties[', '').replace(']', '');
    return { [propertyName]: input.value };
  }
}

// Initialize this custom component
if (!customElements.get('embroidery-configurator-student')) {
  customElements.define('embroidery-configurator-student', EmbroideryConfiguratorStudent);
}
